export enum LocaleCode {
  de_CH = "de-ch",
  de_DE = "de-de",
  fr_FR = "fr-fr",
  en_US = "en-us"
}
